import { Box } from "@mui/material";
import Button from "@mui/material/Button";
// import CustomSelect from "../../../../../components/CustomSelect";
import Flex from "../../../../../components/Flex";
import { ScrollArea } from "../../../../../components/ScrollBar";
import StyledDialog from "../../../../../components/StyledDialog";
import Text from "../../../../../components/Text";
// import { NEW_APPOINTMENT_TYPE } from "../../../../../constants/scheduling";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import { formatDate, formatTime } from "../../../../../utils/date-time-utility";
import { FormikProps } from "formik";
import { FlexCenterWrapper } from "../../../../../components/DefaultNoDataWrapper";

interface SlotAvailabilityModalProps {
  disclosureHost: DisclosureHost;
  formik: FormikProps<any>;
  selectedSlots: any;
}

const SlotAvailabilityModal = ({
  disclosureHost,
  // formik,
  selectedSlots,
}: SlotAvailabilityModalProps) => {
  const formattedDateTitle = formatDate(selectedSlots?.start);

  const newSlots = selectedSlots?.allSlots;

  return (
    <StyledDialog
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      dialogTitle={`Available Slots ${formattedDateTitle || ""}`}
      // FUTURE Reference
      // endIcon={
      //   <Box width={"200px"} mr={5}>
      //     <CustomSelect
      //       value={formik.values?.type}
      //       onChange={(val) => formik.setFieldValue("type", val)}
      //       clearable
      //       placeholder="Appointment Type"
      //       options={NEW_APPOINTMENT_TYPE}
      //     />
      //   </Box>
      // }
    >
      <Flex width={"911px"} height={"22vh"} flexWrap={"wrap"} gap={2} mt={2}>
        {!!newSlots?.length ? (
          <ScrollArea height={"inherit"} width={"100%"}>
            <Flex flexWrap={"wrap"} gap={3}>
              {newSlots?.map((slot: any) => (
                <Box width={"130.5px"} height={"40px"}>
                  <Button
                    // disabled
                    sx={{ width: "100%", height: "100%", borderRadius: 2 }}
                    variant={
                      // formik.values.startTime === slot.startTime &&
                      // formik.values.endTime === slot.endTime
                      //   ? "contained"
                      "outlined"
                    }
                    onClick={() => {
                      //FUTURE Reference
                      // formik.setFieldValue("startTime", slot.startTime);
                      // formik.setFieldValue("endTime", slot.endTime);
                      // formik.setFieldValue("duration", slot.duration);
                      // formik.setFieldValue("timezone", slot.timeZone);
                    }}
                  >
                    {/* - ${formatTime(slot.endTime, {
                      withoutSeconds: true,
                    })}
                       */}
                    <Text>
                      {`${formatTime(slot.startTime)} 
                    `}
                    </Text>
                  </Button>
                </Box>
              ))}
            </Flex>
          </ScrollArea>
        ) : (
          <FlexCenterWrapper>No slots available</FlexCenterWrapper>
        )}
      </Flex>
    </StyledDialog>
  );
};

export default SlotAvailabilityModal;
